let inject = [
  '$scope',
  'SharedService',
  'HomeService',
  '$state',
  '$rootScope',
  '$window',
  '$timeout',
  'MetatagService'
];

class HomeController {
  constructor($scope, SharedService,HomeService, $state, $rootScope, $window, $timeout, MetatagService) {
    this.$state = $state;
    this.$scope = $scope;
    this.$window = $window;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
    this.HomeService = HomeService;
    this.pageName = "PAG-1";

    this.SharedService.getCMSBanners(this.pageName, __env.adaptative ? 1:0).then(response => {
        this.cmsData = response;
        this.shCtrl.setTags(this.cmsData.seo);

    });
    this.$rootScope.$emit('onChangeCompany','');
  }

  $onInit() {

  }



}

HomeController.$inject = inject;

export default HomeController;




/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/home/home.controller.js
 **/